module.exports = __webpack_public_path__ + "distribution/img/log_img_null.d7cff7fa.png";